import React from "react";

export const DETAIL_MEDIA_HEIGHT_CLASS = "h-[33vh] sm:h-[420px]";

const DETAIL_MEDIA_TILE_CLASSES = [
  "col-[2/3] row-[1/2]",
  "col-[3/4] row-[1/2] rounded-tr-3xl",
  "col-[2/3] row-[2/3]",
  "col-[3/4] row-[2/3] rounded-br-3xl",
];

/**
 * Keeps the detail-page media footprint identical while its compact contract
 * is in flight. It is also used as a permanent, non-animated fallback when a
 * record has no publishable photos, so the ready transition cannot collapse.
 */
export const MediaGallerySkeleton = ({
  id = "detail-media-gallery-placeholder",
  className = "",
  heightClass = DETAIL_MEDIA_HEIGHT_CLASS,
  loading = true,
  title = "",
}) => (
  <section
    id={id}
    className={className}
    data-detail-media-state={loading ? "loading" : "empty"}
    aria-busy={loading ? "true" : "false"}
    aria-label={loading ? "Loading photos" : `${title || "Destination"} photos unavailable`}
  >
    <div className="relative overflow-hidden rounded-3xl border border-[#e6edf5] bg-white">
      <div
        className={`grid grid-cols-[minmax(0,2fr)_repeat(2,minmax(0,1fr))] grid-rows-2 gap-1 sm:gap-3 ${heightClass}`}
        aria-hidden={loading ? "true" : undefined}
      >
        <div
          className={`relative col-[1/2] row-[1/3] h-full overflow-hidden rounded-l-3xl bg-[#e7eef4] ${
            loading ? "animate-pulse" : ""
          }`}
        >
          {!loading ? (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 px-6 text-center text-[#64748b]">
              <i className="fa-regular fa-image text-2xl" aria-hidden="true" />
              <span className="text-sm font-semibold">{title || "Destination"} photos coming soon</span>
            </div>
          ) : null}
        </div>
        {DETAIL_MEDIA_TILE_CLASSES.map((placement, index) => (
          <div
            key={`detail-media-placeholder-${index}`}
            className={`${placement} h-full w-full bg-[#eef3f7] ${loading ? "animate-pulse" : ""}`}
          />
        ))}
      </div>
    </div>
  </section>
);

export default MediaGallerySkeleton;
